import styled from "styled-components"

const colorIsDark = (bgColor: string) => {
    const color = (bgColor.charAt(0) === "#") ? bgColor.substring(1, 7) : bgColor
    const r = parseInt(color.substring(0, 2), 16) // hexToR
    const g = parseInt(color.substring(2, 4), 16) // hexToG
    const b = parseInt(color.substring(4, 6), 16) // hexToB
    const uicolors = [r / 255, g / 255, b / 255]
    const c = uicolors.map((col) => {
        if (col <= 0.03928) {
            return col / 12.92
        }
        return ((col + 0.055) / 1.055) ** 2.4
    })
    const L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2])
    return L <= 0.35
}

export const RiskMapTable = styled.table`
    margin: 15px;
`
export const RiskMapTableCell = styled.td<{
    headerCell?: boolean
    centerAlign?: boolean
    background?: string
}>`
    padding: 6px 12px;
    border: 1px solid ${(props) => props.theme.rrsRiskMapTableBorderColor};
    text-align: ${(props) => (props.centerAlign ? "center" : "left")};
    cursor: ${(props) => (props.headerCell ? "default" : "pointer")};

    ${(props) => props.headerCell && `
        font-family: "Open Sans";
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        background: ${props.theme.rrsRiskMapTableHeaderBackground};
    `}

    ${(props) => props.background && `
        background: ${props.background};
        color: ${colorIsDark(props.background) ? "ghostwhite" : "black"};
    `}
`
